import { authFetch } from "@/lib/api-client";
import type { TaskRecord } from "@nexus/contracts";

export async function fetchActiveTasks(): Promise<TaskRecord[]> {
  const result = await authFetch<TaskRecord[]>("/tasks/active");
  return result.data;
}

export async function cancelTask(correlationId: string): Promise<void> {
  await authFetch(`/tasks/${correlationId}/cancel`, {
    method: "POST",
  });
}

/** Remove a task record (clears a terminal card from the sidebar). */
export async function dismissTask(correlationId: string): Promise<void> {
  await authFetch(`/tasks/${correlationId}`, {
    method: "DELETE",
  });
}

/** Dev-only: trigger server-side task simulation for the current user. */
export async function simulateTasks(): Promise<void> {
  await authFetch("/tasks/_dev/simulate", { method: "POST" });
}
